export default {
  sources: state => state.sources
}
